module.exports = __webpack_public_path__ + "images/Fastly-2afea4.png";